import { JsonLd } from "@/components/PageHead";
import { useLanguage } from "@/hooks/useLanguage";
import { uiT } from "@/i18n/ui";
import { SITE_URL } from "@/config/site";
import { localizeHref } from "@/lib/localizeHref";

export interface BreadcrumbItem {
  name: string;
  path?: string; // omit for current page (last item)
}

interface Props {
  items: BreadcrumbItem[];
}

/**
 * Renders a BreadcrumbList JSON-LD script tag.
 * "Home" (localized) is always prepended automatically.
 */
const BreadcrumbJsonLd = ({ items }: Props) => {
  const lang = useLanguage();
  const t = uiT(lang);
  const list = [{ name: t("home"), path: localizeHref("/", lang) }, ...items];

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: list.map((item, i) => {
      const path = item.path ? localizeHref(item.path, lang) : undefined;

      return {
        "@type": "ListItem",
        position: i + 1,
        name: item.name,
        ...(path ? { item: `${SITE_URL}${path}` } : {}),
      };
    }),
  };

  return <JsonLd data={jsonLd} />;
};

export default BreadcrumbJsonLd;
